import store from "@/store";

export default async function notAuth({ next, router }) {
  store.commit("auth/clearErrors");
  const token = localStorage.getItem("authtoken");

  if (token) {
    return router.push({ name: "Dashboard" });
  }

  return next();
}
